module.exports = __webpack_public_path__ + "media/Components/Logos/wwl-logo-32997a8cb6404fffb6e4bee76d06c24b.svg";